import eventDetailsReducer from './eventDetailsReducer';

const rootReducer = {
	eventDetailsReducer
};

export default rootReducer;
